import React from "react";
import css from "./subscription_card.module.scss";

const SubscriptionCard = ({ 
  title = "CORE", 
  price = "$19", 
  period = "/ MO",
  description = "Best for solo creators",
  image = null,
  features = ["100MB Cloud storage", "100+ prompt templates", "5 projects", "24/7 support"],
  isHighlighted = false,
  icon: Icon,
  color = "#00f2ff",
  onClick = null
}) => {
  return (
    <div className={`${css.card_wrap} ${isHighlighted ? css.highlighted : ""}`} style={{ "--accent-color": color }}>
      <div className={css.image_section}>
        {image ? (
          <img src={image} alt={description} className={css.course_image} />
        ) : (
          <div className={css.icon_header}>
            <div className={css.icon_circle}>
               {Icon && <Icon />}
            </div>
          </div>
        )}
      </div>

      <div className={css.card_body}>
        <div className={css.plan_tag}>{title}</div>
        
        <div className={css.price_section}>
          <span className={css.amount}>{price}</span>
          <span className={css.period}>{period}</span>
        </div>
        
        <p className={css.description}>{description}</p>
        
        <div className={css.features_list}>
          {features.map((feature, idx) => (
            <div key={idx} className={css.feature_item}>
              <span className={css.check_icon}>✓</span>
              <span className={css.feature_text}>{feature}</span>
            </div>
          ))}
        </div>
        
        <button className={css.get_started_btn} onClick={onClick}>
          GET STARTED
        </button>
      </div>
    </div>
  );
};

export default SubscriptionCard;
